import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var GraphQLJSError = /*#__PURE__*/function (_Error) {
  function GraphQLJSError(graphQLError) {
    var _this;
    _classCallCheck(this, GraphQLJSError);
    _this = _callSuper(this, GraphQLJSError, [graphQLError.message]);
    _this.name = 'GraphQLJSError';
    _this.error = graphQLError;
    _this.message = graphQLError.message;
    return _this;
  }
  _inherits(GraphQLJSError, _Error);
  return _createClass(GraphQLJSError);
}( /*#__PURE__*/_wrapNativeSuper(Error));